module.exports = __webpack_public_path__ + "img/course-icon-down.fe38427a.svg";